const html = require('choo/html')
const { Button } = require('./elements.js')
const { stop, list, record, zipFile, link } = require('./icons.js')

function ShareButtons(state, emit) {
  return html`
    <ul id="share-button" class="row size-big space-default align-center">
      ${state.isMobile ? '' : html`
        <li class="size-big square">
          ${Button(
            { onClick: () => emit('exportsamplepack') },
            html`<span>${zipFile}</span>`
          )}
        </li>
      `}
      <!-- <li class="size-big square">
        ${Button(
          {
            onClick: () => {
              if (state.agreeWithTerms) {
                emit('sharesamplepack')
              } else {
                emit('startsharing')
              }
            }
          },
          html`<span>${link}</span>`
        )}
      </li> -->
    </ul>
  `
}

module.exports = function SampleBoard(state, emit) {
  function GridButton(sampleId, i) {
    const fileEntry = state.samples.find(f => f.id === sampleId)
    const { value, className } = state.boardLayout[i]
    const sample = state.samples.find(s => s.id === sampleId)
    const dropping = state.selectedSample || state.dragging
    const droppingClass = dropping ? 'dropme' : ''
    function onMouseDown() {
      if (dropping) {
        emit('placesample', i)
      } else {
        emit('playsample', sampleId)
      }
    }
    return html`
      <li class="square size-biggest grid-button ${droppingClass}">
        ${Button(
          {
            onMouseDown: onMouseDown,
            onMouseUp: () => emit('stoploop', sampleId),
            active: state.activeButtons.indexOf(i) !== -1
          },
          html`
            <span class="key ${className}">
              ${value}
            </span>
            <span class="description">
              ${sample ? sample.name : 'empty'}
            </span>
          `
        )}
      </li>
    `
  }

  let samplePackHidden = 'visible'
  if (state.isRecordingOpen) {
    samplePackHidden = 'hidden'
  }

  const openLibraryButton = Button(
    {
        onClick: () => emit('togglesoundlibrary' ),
        active: state.isSoundLibraryOpen
    },
    html`<span>${list}</span>`
  )
  const stopAllSoundsButton = Button(
    { onClick: () => emit('stopallsounds') },
    html`<span>${stop}</span>`
  )
  const openRecordingButton = Button(
    {
      onClick: () => emit('togglerecording' ),
      active: state.isRecordingOpen,
    },
    html`<span>${record}</span>`
  )

  return html`
    <div id="sampler-board" class="row">
      <div class="contour">
        <ul id="grid" class="row space-tight align-center">
          ${state.sampleBoard.map(GridButton)}
        </ul>
        <ul id="sampler-controls" class="row size-big space-default align-center">
          <li id="open-library" class="size-big square">
            ${openLibraryButton}
          </li>
          <li id="stop-sounds" class="size-big square">
            ${stopAllSoundsButton}
          </li>
          ${state.isMobile ? '' : html`
            <li id="open-recording" class="size-big square">
              ${openRecordingButton}
            </li>
          `}
        </ul>
      </div>
      <ul id="sample-packs" class="column space-small align-center ${samplePackHidden}">
        ${state.packs.map((pack) => html`
          <li class="size-big">
            ${Button({ onClick: () => emit('loadpack', pack) }, pack.name)}
          </li>
        `)}
      </ul>
      ${state.customSamplePack ? ShareButtons(state, emit) : null}
    </div>
  `
}
